import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LoadingReact from "../assets/LoadingReact";
import Forecast from "../Components/Forecast";
import Help from "../Components/Help";
import Results from "../Components/Results";
import UserBar from "../Components/UserBar";
import Shopify from "../Components/Shopify";
import { login } from "../app/profile";

const HomePage = () => {
  const dispatch = useDispatch();
  const [weather, setWeather] = useState([]);
  const [loading, setIsLoading] = useState(false);

  const [tempUnit, setTempUnit] = useState(true);

  const tempUnitHandler = () => {
    setTempUnit(!tempUnit);
  };

  const today = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = today.getDate();
  const month = months[today.getMonth()];
  const year = today.getFullYear();
  const final = `${date}-${month}-${year}`;

  const [userInfo, setUserInfo] = useState({
    membership: false,
  });

  const [temps, setTemps] = useState({
    low: "32",
    high: "42",
  });

  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [usps, setUSPS] = useState([]);
  const [ups, setUPS] = useState([]);
  const [ship, setShip] = useState(final);
  const [searchError, setSearchError] = useState("");

  const fetchUser = async () => {
    const graphqlQuery = {
      query: `
                query {
                    user {
                        _id
                        membership
                        pro
                        zip
                        email
                        low
                        high
                    }
                }
                `,
    };

    const res = await fetch(`${process.env.REACT_APP_BACKENDSERVER}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },

      body: JSON.stringify(graphqlQuery),
    });

    const data = await res.json();

    if (data.data.user) {
      setUserInfo(data.data.user);
      setOrigin(data.data.user.zip);
      setTemps({
        low: data.data.user.low,
        high: data.data.user.high,
      });
      dispatch(
        login({
          zip: data.data.user.zip,
          low: data.data.user.low,
          high: data.data.user.high,
          authenticated: data.data.user.membership,
          pro: data.data.user.pro,
        })
      );
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiration = Number(localStorage.getItem("expiration"));

    if (token && expiration > Date.now()) {
      fetchUser();
    }
  }, []);

  const USPSFetch = async () => {
    const fetched = await fetch(
      `${process.env.REACT_APP_BACKENDSERVER}/getusps`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userInfo._id,
          origin: origin,
          destination: destination,
        }),
      }
    ); // fetch the data from the server

    const data = await fetched.json();

    if (!fetched.ok || !Array.isArray(data.data)) {
      throw new Error(data.message || "Failed to fetch USPS data");
    }

    return data.data;
  };

  const USPSFetchPremium = async () => {
    const fetched = await fetch(
      `${process.env.REACT_APP_BACKENDSERVER}/getUSPSPremium`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userInfo._id,
          origin: origin,
          destination: destination,
          ship: ship,
        }),
      }
    ); // fetch the data from the server

    const data = await fetched.json();

    if (!fetched.ok || !Array.isArray(data.data)) {
      throw new Error(data.message || "Failed to fetch premium USPS data");
    }

    return data.data;
  };

  const UPSFetch = async () => {
    const originString = origin.toString();

    let shipFormatted = ship.split("-");
    shipFormatted[1] = months.indexOf(shipFormatted[1]) + 1;
    shipFormatted[1] = shipFormatted[1].toString();

    if (shipFormatted[0].length === 1) {
      shipFormatted[0] = "0" + shipFormatted[0];
    }
    if (shipFormatted[1].length === 1) {
      shipFormatted[1] = "0" + shipFormatted[1];
    }

    shipFormatted = shipFormatted.reverse().join("");

    const fetched = await fetch(
      `${process.env.REACT_APP_BACKENDSERVER}/getUPS`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userInfo._id,
          origin: originString,
          destination: destination,
          ship: shipFormatted,
        }),
      }
    );

    const data = await fetched.json();

    if (!fetched.ok || !Array.isArray(data.data)) {
      throw new Error(data.message || "Failed to fetch UPS data");
    }

    return data.data;
  };
  const weatherHandler = async () => {
    const fetched = await fetch(
      `${process.env.REACT_APP_BACKENDSERVER}/fetch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          origin: origin,
          destination: destination,
        }),
      }
    );

    const data = await fetched.json();

    if (!fetched.ok || !Array.isArray(data.data)) {
      throw new Error(data.message || "Failed to fetch weather data");
    }

    return data.data;
  };

  const fetchDataHandler = async (e) => {
    e.preventDefault();
    setWeather([]);
    setUSPS([]);
    setUPS([]);
    setSearchError("");
    setIsLoading(true);

    try {
      const [uspsResult, weatherResult] = await Promise.allSettled([
        USPSFetch(),
        weatherHandler(),
      ]);

      const errors = [];

      if (uspsResult.status === "fulfilled") {
        setUSPS(uspsResult.value);
      } else {
        errors.push(
          uspsResult.reason?.message || "USPS data could not be loaded."
        );
      }

      if (weatherResult.status === "fulfilled") {
        setWeather(weatherResult.value);
      } else {
        errors.push(
          weatherResult.reason?.message || "Weather data could not be loaded."
        );
      }

      if (errors.length > 0) {
        setSearchError(errors.join(" "));
      }
    } catch (err) {
      console.error("Search request failed:", err);
      setSearchError("Something went wrong while fetching shipping data.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataPremiumHandler = async (e) => {
    e.preventDefault();
    setWeather([]);
    setUSPS([]);
    setUPS([]);
    setSearchError("");
    setIsLoading(true);

    try {
      const [uspsResult, upsResult, weatherResult] = await Promise.allSettled([
        USPSFetchPremium(),
        UPSFetch(),
        weatherHandler(),
      ]);

      const errors = [];

      if (uspsResult.status === "fulfilled") {
        setUSPS(uspsResult.value);
      } else {
        errors.push(
          uspsResult.reason?.message || "USPS data could not be loaded."
        );
      }

      if (upsResult.status === "fulfilled") {
        setUPS(upsResult.value);
      } else {
        errors.push(upsResult.reason?.message || "UPS data could not be loaded.");
      }

      if (weatherResult.status === "fulfilled") {
        setWeather(weatherResult.value);
      } else {
        errors.push(
          weatherResult.reason?.message || "Weather data could not be loaded."
        );
      }

      if (errors.length > 0) {
        setSearchError(errors.join(" "));
      }
    } catch (err) {
      console.error("Premium search request failed:", err);
      setSearchError("Something went wrong while fetching premium shipping data.");
    } finally {
      setIsLoading(false);
    }
  };

  const originHandler = (e) => {
    setOrigin(e.target.value);
  };

  const shipDateHandler = (e) => {
    const today = new Date();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    today.setDate(today.getDate() + parseInt(e.target.value));
    const date = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    const final = `${date}-${month}-${year}`;

    setShip(final);
  };

  const destinationHandler = (e) => {
    setDestination(e.target.value);
  };

  return (
    <>
      <UserBar />
      <div className="flex font-sans flex-col justify-center items-center w-full  min-h-screen text-center ">
        <Shopify/>
        <h1 className="text-5xl md:text-6xl font-bold text-sky-950 p-2 md:mt-4 md:mb-2 mt-3 mb-2">
          Welcome to WeatherIShip
        </h1>
        <h3 className="text-lg md:text-xl font-normal text-slate-800 px-4 md:px-0 md:w-2/4">
          Easily see if your temperature-sensitive products are safe to ship. Enter your destination/origin zip codes to get started.
        </h3>
        {!userInfo.membership ? (
          <form
            onSubmit={fetchDataHandler}
            className="flex  justify-center p-10 flex-col md:flex-row md:space-x-2"
          >
            <input
              name="shipDate"
              id="shipDate"
              onChange={shipDateHandler}
              disabled
              className="p-4 m-2 md:m-0 disabled:border-slate-300 disabled:border-2"
              placeholder="Ship Date"
            />
            <input
              type="text"
              className="p-4 m-2 md:m-0 border"
              placeholder="Origin Zip Code"
              onChange={originHandler}
              minLength="5"
              maxLength="5"
              required
              defaultValue={origin}
            />
            <input
              type="text"
              className="p-4 m-2 md:m-0 border"
              placeholder="Destination Zip Code"
              onChange={destinationHandler}
              minLength="5"
              required
              maxLength="5"
            />
            <button
              type="submit"
              className="p-4 m-2 md:m-0 shadow-md bg-sky-700 text-slate-50 font-semibold rounded-lg hover:bg-sky-600"
            >
              Search
            </button>
          </form>
        ) : (
          <form
            onSubmit={fetchDataPremiumHandler}
            className="flex  justify-center p-10 flex-col md:flex-row md:space-x-2"
          >
            <select
              name="shipDate"
              id="shipDate"
              onChange={shipDateHandler}
              className="p-4 m-2 md:m-0 disabled:border-slate-300 disabled:border-2"
            >
              <option value="0">Today</option>
              <option value="1">Tomorrow</option>
              <option value="2">Day After Tomorrow</option>
            </select>
            <input
              type="text"
              className="p-4 m-2 md:m-0"
              placeholder="Origin Zip Code"
              onChange={originHandler}
              minLength="5"
              maxLength="5"
              required
              defaultValue={origin}
            />
            <input
              type="text"
              className="p-4 m-2 md:m-0"
              placeholder="Destination Zip Code"
              onChange={destinationHandler}
              minLength="5"
              required
              maxLength="5"
            />
            <button
              type="submit"
              className="p-4 m-2 md:m-0 shadow-md bg-sky-700 text-slate-50 font-semibold rounded-lg hover:bg-sky-600"
            >
              Search
            </button>
          </form>
        )}
        {searchError && (
          <div className="mx-4 my-2 max-w-3xl rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-800">
            {searchError}
          </div>
        )}
        {loading && <LoadingReact />}

        {weather && usps && weather.length > 0 && usps.length > 0 && (
          <Forecast
            weather={weather}
            services={usps}
            user={userInfo}
            ups={ups}
            tempUnit={tempUnit}
          />
        )}
        {weather && usps && ups && usps.length > 0 && weather.length > 0 && (
          <Results
            services={usps}
            ups={ups}
            weather={weather}
            low={temps.low}
            high={temps.high}
            tempUnit={tempUnit}
          />
        )}
        <div className="flex md:block">
          <Help />
          <div
            onClick={tempUnitHandler}
            className="md:fixed  h-16 bg-sky-600 min-width-max rounded-3xl flex justify-center items-center md:bottom-10 md:left-10 hover:bg-sky-500 cursor-pointer transition transition-all duration-300 m-5"
          >
            {!tempUnit && (
              <p className="mx-5 text-slate-100 text-2xl font-semibold tracking-tighter mb-1">
                F °
              </p>
            )}
            {tempUnit && (
              <p className="mx-5 text-slate-100 text-2xl font-semibold tracking-tighter mb-1">
                C °
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default HomePage;
